import { render, staticRenderFns } from "./wasserstoff.vue?vue&type=template&id=6395439e&"
import script from "./wasserstoff.vue?vue&type=script&lang=js&"
export * from "./wasserstoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports